export const calculateLoan = (credito, interesPercent, cuotas) => {
  const round2 = (value) => Math.round((Number(value) + Number.EPSILON) * 100) / 100;

  const principal = parseFloat(credito);
  const tasaInteres = parseFloat(interesPercent);
  const periods = parseInt(cuotas, 10);

  if (isNaN(principal) || isNaN(tasaInteres) || isNaN(periods) || periods <= 0) {
    return {
      total: '',
      cuota: '',
      percentTotal: '',
      interesGenerado: '',
      montoDeOtros: '',
      otrosPorCuota: []
    };
  }

  const paso1 = round2(principal * 0.01);
  const sumaInicial = round2(principal + paso1);
  const interesCalculado = round2(sumaInicial * (tasaInteres / 100));
  const totalAPagar = round2(sumaInicial + interesCalculado);

  const cuota = round2(totalAPagar / periods);
  const totalAPagarReal = round2(cuota * periods);

  const interesDelCapital = round2(principal * (tasaInteres / 100));
  const montoDeOtros = round2(totalAPagarReal - principal - interesDelCapital);

  const otrosPorCuota = [];
  const otrosUnit = periods > 0 ? round2(montoDeOtros / periods) : 0;
  let acumulado = 0;

  for (let i = 0; i < periods; i++) {
    if (i < periods - 1) {
      otrosPorCuota.push(otrosUnit);
      acumulado = round2(acumulado + otrosUnit);
    } else {
      otrosPorCuota.push(round2(montoDeOtros - acumulado));
    }
  }

  const percentTotal = ((totalAPagarReal / principal) * 100).toFixed(2) + '%';

  return {
    total: totalAPagarReal.toFixed(2),
    cuota: cuota.toFixed(2),
    percentTotal,
    interesGenerado: interesDelCapital.toFixed(2),
    montoDeOtros: montoDeOtros.toFixed(2),
    otrosPorCuota
  };
};